var _style, _path, _g, _g2, _g3, _g4, _g5, _g6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGithubIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 1000",
    style: {
      enableBackground: "new 0 0 1000 1000"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#F0F0F3;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    className: "st0",
    d: "M499.9,34.7c-263.5,0-477.1,213.6-477.1,477.2c0,205.4,131.5,387.8,326.4,452.7 c23.9,4.4,32.6-10.3,32.6-23c0-11.3-0.4-41.3-0.6-81.2c-132.7,28.8-160.7-63.9-160.7-63.9c-21.7-55.1-53-69.8-53-69.8 c-43.3-29.6,3.3-29,3.3-29c30.6,4.2,57.6,22.4,73.1,49.1c42.6,72.9,111.7,51.9,138.9,39.6c2.2-24.2,12.9-46.8,30.3-63.8 c-105.9-12-217.3-53-217.3-235.8c-0.7-47.4,16.9-93.2,49.1-128c-14.6-41.2-12.9-86.3,4.7-126.3c0,0,40.1-12.8,131.2,48.9 c78.2-21.4,160.7-21.4,238.9,0c91.1-61.7,131.1-48.9,131.1-48.9c17.6,40,19.3,85.1,4.8,126.3c32.2,34.8,49.8,80.7,49,128.1 c0,183.3-111.6,223.6-217.9,235.4c23,23.4,34.8,55.6,32.4,88.4c0,63.8-0.6,115.3-0.6,130.9c0,12.7,8.6,27.6,32.8,22.9 c250-83.4,385-353.7,301.5-603.7C887.5,166,705.2,34.7,499.9,34.7L499.9,34.7z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithubIcon);
export default __webpack_public_path__ + "static/media/github-icon.9075a13abf5b5a53732bdaaff8fa376d.svg";
export { ForwardRef as ReactComponent };